import React, { useState, useEffect } from "react";
import { PROFILE_COMPLETION_FOCUS_TABS } from "../constants/stringConstants";
import "../css/profile.css";

type CompleteProfileInfoAreaProps = {
  focusTab: string;
};

function CompleteProfileInfoArea(props: CompleteProfileInfoAreaProps) {
  return (
    <div className="complete_profile_heading">
      <h3>Complete your profile</h3>
      <div className="content-tabs">
        <p
          className={`content-tab1 ${
            props.focusTab === PROFILE_COMPLETION_FOCUS_TABS.TARGET
              ? "content-tab1-active"
              : ""
          }`}
        >
          <span className="rounded-nums1 ">1</span> Target
        </p>
        <p
          className={`content-tab2 ${
            props.focusTab === PROFILE_COMPLETION_FOCUS_TABS.JOB_DETAILS
              ? "content-tab2-active"
              : ""
          }`}
        >
          <span className="rounded-nums2">2</span> Job Details
        </p>
        <p
          className={`content-tab3 ${
            props.focusTab === PROFILE_COMPLETION_FOCUS_TABS.JOB_RELATED_INFO
              ? "content-tab3-active"
              : ""
          }`}
        >
          <span className="rounded-nums3">3</span> Review and Publish
        </p>
      </div>
    </div>
  );
}

export default CompleteProfileInfoArea;
